import combineReducers from '../../../utilities/combine-reducers';
import createReducer from '../../../utilities/create-reducer';
import * as actions from './actions';
import { FeatureFlagsStatus } from './constants';

const featureFlagsStatus = createReducer({
  [actions.LOAD_FEATURE_FLAGS_DATA]: () => FeatureFlagsStatus.LOADING,
  [actions.SET_FEATURE_FLAGS_STATUS]: (state, { payload }) => payload,
});

const featureFlagsData = createReducer({
  [actions.LOAD_FEATURE_FLAGS_DATA]: () => null,
  [actions.SET_FEATURE_FLAGS_DATA]: (state, { payload }) => payload,
});

const reducer = combineReducers({ featureFlagsStatus, featureFlagsData });
const initialState = {
  featureFlagsStatus: FeatureFlagsStatus.IDLE,
  featureFlagsData: null,
};

export default (state = initialState, action) => reducer(state, action);
